import { ClientSecret } from "api/account/client";
import { SvgIconName } from "components/components/Icon/Icon";
import SecretStatus from "components/components/Iris/AuthenticatedView/IrisDetailsPage/IrisDetails/SecretsTable/SecretStatus";
import {
  DeleteSecretButton,
  SecretsActionCell,
} from "components/components/Iris/AuthenticatedView/IrisDetailsPage/IrisDetails/SecretsTable/style";
import LineTable from "components/components/LineTable/LineTable";
import React from "react";
import { DateFormat, formatDateTimeString } from "utils/dateHelpers";

type Props = {
  applicationSecrets: ClientSecret[];
  deleteDisabled: boolean;
  setSecretToDelete: (s: ClientSecret) => void;
};

const SecretsTable: React.FC<Props> = ({
  applicationSecrets,
  deleteDisabled,
  setSecretToDelete,
}) => {
  const headers: React.ReactNode[] = [
    "Secret Hint",
    "Expiry date",
    "Status",
    "Action",
  ];

  return (
    <LineTable
      ariaLive="polite"
      items={applicationSecrets}
      headers={headers}
      getRowValues={(s): React.ReactNode[] => [
        <>{s.secretHint.padEnd(18, "*")}</>,
        <>
          {formatDateTimeString(new Date(s.expiryTime), DateFormat.DateOnly)}
        </>,
        <SecretStatus key="status" secret={s} />,
        <SecretsActionCell key="action">
          <DeleteSecretButton
            ariaLabel="delete"
            buttonText="Delete"
            iconName={SvgIconName.Delete}
            onClick={(): void => setSecretToDelete(s)}
            disabled={deleteDisabled}
            textLeftOfIcon
          />
        </SecretsActionCell>,
      ]}
      emptyCell={<>—</>}
    />
  );
};

export default SecretsTable;
